import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// جلب رابط الـ API فقط من ملف .env
const API_BASE_URL = process.env.REACT_APP_API_PLAN_URL;

export const loginUser = createAsyncThunk(
  'auth/loginUser',
  async ({ userId, password }, { rejectWithValue }) => {
    try {
      // إرسال الطلب بالبيانات المدخلة من الفورمة فقط
      const response = await axios.post(`${API_BASE_URL}auth/login`, {
        userId,
        password
      });

      // حفظ التوكن في التخزين المحلي
      if (response.data.token) {
        localStorage.setItem('userToken', response.data.token);
      }

      return response.data;
    } catch (error) {
      console.error("Login Error:", error);
      return rejectWithValue(
        error.response?.data?.message || "فشل تسجيل الدخول"
      );
    }
  }
);

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    user: null,
    token: localStorage.getItem('userToken') || null,
    isAuthenticated: !!localStorage.getItem('userToken'),
    loading: false,
    error: null,
  },
  reducers: {
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;
      localStorage.removeItem('userToken');
      localStorage.removeItem('user');
      localStorage.removeItem('isLoggedIn');
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.isAuthenticated = true;
        state.user = action.payload.user; 
        state.token = action.payload.token;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.isAuthenticated = false;
      });
  },
});

export const { logout } = authSlice.actions;
export default authSlice.reducer;